const routes = [
  {
    path: '/hardwares',
    component: () => import('./1index.vue'),
  },
];

export default routes;
